<template>
  <div class="voucher-code container full-width">
    <div class="text-subtitle1">Villa's Gift Voucher</div>
    <div class="flex" :class="{ 'q-mb-sm': value?.length > 0 }">
      <q-chip
        color="primary"
        text-color="white"
        removable
        @remove="onRemoveVoucher(voucher)"
        v-for="voucher in value"
        :key="voucher"
        >{{ voucher }}</q-chip
      >
    </div>
    <q-form @submit.prevent="onApplyVoucherCode" class="flex no-wrap">
      <q-input
        v-model="voucher"
        class="bg-white full-width"
        placeholder="Enter voucher code"
        dense
        outlined
        clearable
        mask="XXXXXXXX"
      />
      <q-btn
        type="submit"
        class="q-ml-sm"
        flat
        no-caps
        color="primary"
        label="Apply"
      ></q-btn>
    </q-form>
  </div>
</template>

<script>
export default {
  name: "VoucherCode",
  data() {
    return {
      voucher: "",
    };
  },
  computed: {
    value() {
      return this.$store.state["checkout"]["voucherId"];
    },
  },
  methods: {
    async onApplyVoucherCode() {
      console.log("onApplyVoucherCode", this.voucher);
      if (this.voucher.trim().length > 0) {
        if (this.value?.findIndex((v) => v === this.voucher) >= 0) {
          // duplicate voucher
          this.voucher = "";
          return;
        }

        const vouchers = [...this.value];
        vouchers.push(this.voucher);

        const voucherTemp = this.voucher;

        this.voucher = "";
        this.$store.commit("checkout/setVoucherId", vouchers);

        const success = await this.$store.dispatch("checkout/getCost");
        if (!success) {
          this.onRemoveVoucher(voucherTemp);
          this.$q
            .dialog({
              title: "Error",
              message: "Voucher code invalid or expired.",
            })
            .onOk(() => {
              // console.log('OK')
            })
            .onCancel(() => {
              // console.log('Cancel')
            })
            .onDismiss(() => {
              // console.log('I am triggered on both OK and Cancel')
            });
        }
      }
    },
    onRemoveVoucher(voucher) {
      console.log("onRemoveVoucher", voucher);
      const vouchers = [...this.value];
      const filteredVoucher = vouchers.filter((v) => v !== voucher);
      this.$store.commit("checkout/setVoucherId", filteredVoucher);
      this.$store.dispatch("checkout/getCost");
    },
  },
};
</script>

<style scoped>
.container {
  padding: 0px 8px;
}
</style>
